<template>
    <div class="home">
        <HeroBanner />
        <AboutSection />
        <ServicesSection />
        <BenefitsSection />
        <TestimonialsSection />
        <ContactCta />
    </div>
</template>

<script>
import HeroBanner from '@/components/sections/HeroBanner.vue'
import AboutSection from '@/components/sections/AboutSection.vue'
import ServicesSection from '@/components/sections/ServicesSection.vue'
import BenefitsSection from '@/components/sections/BenefitsSection.vue'
import TestimonialsSection from '@/components/sections/TestimonialsSection.vue'
import ContactCta from '@/components/sections/ContactCta.vue'

export default {
    name: 'HomeView',
    components: {
        HeroBanner,
        AboutSection,
        ServicesSection,
        BenefitsSection,
        TestimonialsSection,
        ContactCta
    }
}
</script>